<template>
    <div class="email-preview">
        <h2>{{ $t('support.emailPreviewDetails.header') }}</h2>

        <table class="table table-hover">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Beschriebung</th>
                    <th>Link</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>25-Tage-Mail</td>
                    <td>Testphase</td>
                    <td>E-Mail nach 25 Tagen Testphase</td>
                    <td><a href="/emails/day25" target="_blank">E-Mail Vorschau</a></td>
                </tr>
                <tr>
                    <td>30-Tage-Mail</td>
                    <td>Testphase</td>
                    <td>E-Mail nach 30 Tagen Testphase</td>
                    <td><a href="/emails/day30" target="_blank">E-Mail Vorschau</a></td>
                </tr>
                <tr>
                    <td>45-Tage-Mail</td>
                    <td>Testphase</td>
                    <td>E-Mail nach 45 Tagen Testphase</td>
                    <td><a href="/emails/day45" target="_blank">E-Mail Vorschau</a></td>
                </tr>
                <tr>
                    <td>80-Tage-Mail</td>
                    <td>Testphase</td>
                    <td>E-Mail nach 80 Tagen Testphase</td>
                    <td><a href="/emails/day80" target="_blank">E-Mail Vorschau</a></td>
                </tr>
                <tr>
                    <td>90-Tage-Mail</td>
                    <td>Testphase</td>
                    <td>E-Mail nach 90 Tagen Testphase</td>
                    <td><a href="/emails/day90" target="_blank">E-Mail Vorschau</a></td>
                </tr>
                <tr>
                    <td>welcomeNewInstance</td>
                    <td>Testphase</td>
                    <td>E-Mail nach erfolgreicher CT Erstellung</td>
                    <td><a href="/emails/welcomeNewInstance" target="_blank">E-Mail Vorschau</a></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            search: ''
        };
    },
    props: ['instance']
};
</script>
